<script>
    export default {
        computed: {
            fileInPage() {return this.$store.getters.FILE_IN_PAGE},
        },
        methods: {
            async changeFileInPage(event) {
                this.$store.commit('FILE_IN_PAGE', event.target.value);
                this.$store.dispatch('SAVE_LOCAL_STORAGE');
            }
        }
    }
</script>


<template>
    <div class="setting_file_edit">
        <label
            class="setting_header"
        >Page File Edit:</label>
        <label>File Count In Page:</label>
        <div
            class="left_sub_multi_container mt_5"
        >
            <input 
                :value="fileInPage"
                @change="changeFileInPage"
                class="right_input"
                type="number"
                min="1"
            >
            <button
                class="ml_10 button_blue_150"
            >Save</button>
        </div>
    </div>
</template>